import Tooltip from "../tooltip";
import FormSystemError from "../../../utils/form-error-constants";

class Login {
    constructor() {
        this.formErrorConstants = new FormSystemError('#loginForm');
        this.formErrorConstants.init();
    }

    init() {
        let formSystemError = new FormSystemError();
        formSystemError.init();

        this.submitLogin();
    }

    submitLogin() {
        let tooltip = new Tooltip();
        tooltip.init();
        let form = $('#loginForm');

        if (form.find('#g-recaptcha').length) {
          form.on('click', '.submitButton', {'form': form}, event => {
            let allowSendForm = true;
            event.preventDefault();

            let form = event.data.form;
            this.formErrorConstants.removeErrors(form);
            this.formErrorConstants.removeDataError(form);
            form.find('input:required').not(':button, :hidden').each(function(i, element) {
                  let errorMessage = $(element).data('error-message');
                  if (errorMessage) {
                    let value = $(element).val();
                    if (!value || value.length === 0) {
                      allowSendForm = false;
                      $(element).attr('data-error', errorMessage);
                    }
                  }
                });

            let $regid = $('input[name=regid]');

            if (!$regid.val().length) {
              $regid.attr('data-error', this.formErrorConstants.constants.regid);
              allowSendForm = false;
            }

            if (allowSendForm) {
              grecaptcha.execute(widgetId1);
            } else {
              this.formErrorConstants.init();
            }
          });
        }
    }
}

$(document).ready(function () {
    let login = new Login();
    login.init();
});
